/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Preview_UnavailableInputs */

const es_co2_export_preview_unavailable = /** @type {(inputs: Export_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos verificar este preview. Recarga la página o solicita una nueva exportación.`)
};

/**

* @param {Export_Preview_UnavailableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const export_preview_unavailable = /** @type {((inputs?: Export_Preview_UnavailableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Preview_UnavailableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_export_preview_unavailable(inputs)
});